<template>
  <v-form v-model="isValid">
    <v-card>
      <v-card-title>{{ createSubject() }}</v-card-title>
      <v-card-text>
        <div class="popup__desc--empty" />
        <div class="app__form">
          <div class="formItem formItem--1x12">
            <v-text-field
              id="email"
              v-model="contactForm.email"
              :label="t('form.common.email')"
              :rules="[rules.required, rules.isEmail]"
              :error-messages="get(errorMessages, 'email')"
              type="email"
              required
            />
          </div>
          <div class="formItem formItem--1x12">
            <v-textarea
              id="content"
              v-model="contactForm.content"
              :label="t('form.contact.text')"
              :rules="[rules.required]"
              :error-messages="get(errorMessages, 'text')"
              :auto-grow="true"
              required
            />
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          id="send_email"
          class="mbtn mbtn--green"
          size="x-large"
          :disabled="!isValid"
          type="submit"
          :loading="load"
          @click.prevent="Send"
        >
          {{ t("form.contact.send") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script setup lang="ts">
import { get } from "lodash-es";

const { rules } = useFormValidators();
const { t } = useI18n();
const authStore = useAuthStore();
const partnerStore = usePartnerStore();
const { notify } = useNotification();
const isValid = ref<boolean>(false);
const { $api } = useNuxtApp() as { $api: IApiInstance };

const props = withDefaults(defineProps<{
  subject?: string | null;
  text?: string | null;
}>(), {
  subject: null,
  text: null
});

interface ContactForm {
  subject: string;
  email: string;
  content: string;
  partner: string | null;
}

const contactForm = reactive<ContactForm>({
  subject: t("form.contact.text_title"),
  email: authStore.data?.username ?? "",
  content: "",
  partner: partnerStore.partner?.fe_name || ""
});

const load = ref<boolean>(false);
const errorMessages = ref<string[] | null>(null);
const emit = defineEmits(["closeDialog"]);

async function Send () {
  errorMessages.value = null;
  load.value = true;
  contactForm.partner = partnerStore.partner?.fe_name ?? "";
  const { error } = await $api.user.contactUs({
    ...contactForm,
    email: contactForm.email.toLowerCase()
  });

  if (error.value) {
    notify({
      title: t("form.common.error"),
      text: error.value!.data?.detail ?? t("general.error_sending_request"),
      type: "error"
    });
    errorMessages.value = error.value?.data;
  } else {
    notify({
      title: t("form.common.email_send"),
      type: "success"
    });
    emit("closeDialog");
  }
  load.value = false;
}

function createSubject () {
  if (props.text) { contactForm.content = props.text; }
  if (props.subject) {
    contactForm.subject = props.subject;
  }
  return contactForm.subject;
}

</script>
